function effectiveBearerString(bearerTokenString) {
  if (bearerTokenString == null) return null;
  const trimmedTokenOrLiteral = String(bearerTokenString).trim();
  if (trimmedTokenOrLiteral === '' || trimmedTokenOrLiteral === 'null' || trimmedTokenOrLiteral === 'undefined') {
    return null;
  }
  return trimmedTokenOrLiteral;
}

function withoutAuthorizationHeader(headers) {
  return Object.keys(headers).reduce((sanitizedHeaders, headerName) => {
    if (headerName.toLowerCase() !== 'authorization') {
      return {
        ...sanitizedHeaders,
        [headerName]: headers[headerName],
      };
    }
    return sanitizedHeaders;
  }, {});
}

function isInvalidAuthorizationHeader(value) {
  if (value == null) {
    return true;
  }
  const normalizedValue = String(value).trim().toLowerCase();
  return [
    '',
    'bearer',
    'bearer null',
    'bearer undefined',
    'null',
    'undefined',
  ].includes(normalizedValue);
}

function sanitizeInvalidAuthorizationHeader(headers) {
  return Object.keys(headers).reduce((sanitizedHeaders, headerName) => {
    if (headerName.toLowerCase() === 'authorization' && isInvalidAuthorizationHeader(headers[headerName])) {
      return sanitizedHeaders;
    }
    return {
      ...sanitizedHeaders,
      [headerName]: headers[headerName],
    };
  }, {});
}

export function applyCookieCredentials(config) {
  return {
    ...config,
    headers: sanitizeInvalidAuthorizationHeader(config.headers || {}),
    withCredentials: true,
  };
}

export function applyBearerOrCookie(baseConfig, bearerTokenString) {
  const merged = {
    ...baseConfig,
    headers: withoutAuthorizationHeader(baseConfig.headers || {}),
    withCredentials: true,
  };
  const validatedAccessTokenForHeader = effectiveBearerString(bearerTokenString);
  if (validatedAccessTokenForHeader) {
    merged.headers.Authorization = `Bearer ${validatedAccessTokenForHeader}`;
  }
  return merged;
}

export function applyAuthToXhr(xhr, bearerTokenString) {
  /* eslint-disable no-param-reassign */
  const validatedAccessTokenForHeader = effectiveBearerString(bearerTokenString);
  xhr.withCredentials = true;
  if (validatedAccessTokenForHeader) {
    xhr.setRequestHeader('Authorization', `Bearer ${validatedAccessTokenForHeader}`);
  }
  /* eslint-enable no-param-reassign */
}
